export default __webpack_public_path__ + "static/media/armSwing_murai.15cc0553.png";